module.exports = __webpack_public_path__ + "img/top_pc.f621ce57.png";